import React from "react";
import { Snackbar, makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    top: theme.spacing(9),
    paddingRight: theme.spacing(2),
  },
  alert: {
    userSelect: "text", // Enable text selection for Alert component
    pointerEvents: "auto", // Ensure pointer events are enabled
  },
  message: {
    userSelect: "text", // Enable text selection for the message specifically
  },
}));

export default function Notification(props) {
  const { notify, setNotify } = props;

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  return (
    <Snackbar
      className={classes.root}
      open={notify.isOpen}
      autoHideDuration={notify.hide === true ? 10000 : undefined}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert 
        className={classes.alert} // Apply the alert style here
        severity={notify.type} 
        onClose={handleClose}
      >
        <span className={classes.message}>{notify.message}</span> {/* Make this specific text selectable */}
      </Alert>
    </Snackbar>
  );
}
